import type { ApiClient } from "./client";

export interface BranchRef { id: string; name: string }

/** `PickerEntry` from workers/api/src/auth/access.ts. */
export interface PickerEntry {
  businessId: string;
  name: string;
  staff: { roleId: string; branches: BranchRef[] } | null;
  member: { branches: BranchRef[] } | null;
}

export interface OtpStartResult { challengeId: string; expiresAt: number }
export interface OtpVerifyResult { token: string; expiresAt: number; personId: string; deviceId: string; businesses: PickerEntry[] }
export interface SelectResult { token: string; expiresAt: number; businessId: string; branchId: string; actingAs: "staff" | "member"; deviceId: string; staffId?: string; roleId?: string }

export const startOtp = (c: ApiClient, v: { phone: string; deviceId: string; botToken?: string }) =>
  // Bot check: `botToken` is optional on main. The hook is here; nothing is sent until a widget exists.
  c.post<OtpStartResult>("/auth/otp/start", { phone: v.phone, deviceId: v.deviceId, ...(v.botToken ? { botToken: v.botToken } : {}) });

export const verifyOtp = (c: ApiClient, v: { challengeId: string; code: string; deviceId: string; trustDevice: boolean }) =>
  c.post<OtpVerifyResult>("/auth/otp/verify", v);

export const selectSession = (c: ApiClient, v: { businessId: string; branchId?: string }) =>
  c.post<SelectResult>("/auth/session/select", { ...v, as: "staff" });

export const listBusinesses = (c: ApiClient) => c.get<{ businesses: PickerEntry[] }>("/auth/businesses").then((r) => r.businesses);
export const logout = (c: ApiClient) => c.post<{ ok: true }>("/auth/logout");
export const logoutAll = (c: ApiClient) => c.post<{ ok: true }>("/auth/logout-all");
